import React from 'react';
import clsx from 'clsx';
import { ButtonLink } from '../ButtonLink/ButtonLink';
import { ArrowBackIos } from '@material-ui/icons';
import { useStyles } from './BackButton.styles';

interface IBackButtonProps {
  link: string;
  disableMargin?: boolean;
}

export const BackButton = (props: IBackButtonProps) => {
  const { link, disableMargin } = props;
  const classes = useStyles();
  return (
    <ButtonLink
      className={clsx({ [classes.margin]: !disableMargin })}
      to={link}
      text={'component.back-button.back'}
      icon={<ArrowBackIos />}
      variant="text"
    />
  );
};
